import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/AxiosInstance";

export const fetchPendingReportThunk = createAsyncThunk(
  "pendingReport/fetch",
  async (filters, { rejectWithValue }) => {
    try {
      const params = {
        from_date: filters?.from_date || "",
        ward_id: filters?.ward_id || "",
      };

      const res = await api.get("/api/reports/pending-report", {
        params,
      });

      if (!res.data?.success) {
        return rejectWithValue(
          res.data?.message || "Failed to load report"
        );
      }

      return {
        rows: res.data?.data || [],
        meta: res.data?.meta || {},
      };
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message ||
          err.message ||
          "Server error"
      );
    }
  }
);

const pendingReportSlice = createSlice({
  name: "pendingReport",

  initialState: {
    rows: [],
    meta: {},
    loading: false,
    error: null,
  },

  reducers: {
    clearPendingReport: (state) => {
      state.rows = [];
      state.meta = {};
      state.loading = false;
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchPendingReportThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchPendingReportThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.rows = action.payload?.rows || [];
        state.meta = action.payload?.meta || {};
      })

      .addCase(fetchPendingReportThunk.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload || "Failed to load report";
      });
  },
});

export const {
  clearPendingReport,
} = pendingReportSlice.actions;

export default pendingReportSlice.reducer;